import {
  type ECategoryMap,
  type ESceneMap,
  type ESelected,
  type GeneralID,
  type STMapMarker,
  TemplateId,
  type TourData,
} from '@types';
import {
  $categoryListApi,
  $categoryMapApi,
  $curSandTableIdApi,
  $largestCategoryIdApi,
  $origSceneIdsApi,
  $origSceneMapApi,
  $origTourDataApi,
  $sceneMapApi,
  $selectedPathApi,
  $tourDataApi,
} from '@stores/dataStores';

function dataHandler(
  data: TourData,
  options: {
    selectedPath?: ESelected;
  } = {}
) {
  const { category, scenes } = data;
  const categoryIds: number[] = [];
  const categoryMap: ECategoryMap = new Map();
  const sceneMap: ESceneMap = new Map();
  const origSceneIds: GeneralID[] = [];
  let largestCategoryId = 0;
  for (let i = 0; i < category.length; i++) {
    const item = category[i];
    if (item.id > largestCategoryId) {
      largestCategoryId = item.id;
    }
    categoryIds.push(item.id);
    const children = item.children || [];
    categoryMap.set(item.id, {
      id: item.id,
      name: item.name,
      categoryIds: children.map((x) => x.id),
      sceneIds: [],
    });
    for (let j = 0; j < children.length; j++) {
      const subItem = children[j];
      if (subItem.id > largestCategoryId) {
        largestCategoryId = subItem.id;
      }
      categoryMap.set(subItem.id, {
        id: subItem.id,
        name: subItem.name,
        categoryIds: [],
        sceneIds: [],
      });
    }
  }
  scenes
    .sort((a, b) => a.sort - b.sort)
    .forEach((item) => {
      categoryMap.get(item.categoryId)?.sceneIds.push(item.id);
      sceneMap.set(item.id, item);
      origSceneIds.push(item.id);
    });

  $categoryMapApi.init(categoryMap);
  $categoryListApi.init(categoryIds);
  $sceneMapApi.init(sceneMap);
  $origSceneMapApi.init(sceneMap);
  $origSceneIdsApi.set(origSceneIds);
  $largestCategoryIdApi.set(largestCategoryId);

  if (options.selectedPath) {
    $selectedPathApi.update(() => options.selectedPath);
  } else {
    const initialSubId = categoryMap.get(categoryIds[0])?.categoryIds[0];
    if (initialSubId) {
      $selectedPathApi.update(() => ({
        id: categoryMap.get(initialSubId)?.sceneIds[0] ?? null,
        categoryPath: [categoryIds[0], initialSubId],
      }));
    } else {
      $selectedPathApi.update(() => ({
        id: categoryMap.get(categoryIds[0])?.sceneIds[0] ?? null,
        categoryPath: [categoryIds[0]],
      }));
    }
  }

  const sandTableId = data.sandBox?.[0]?.id ?? null;
  $curSandTableIdApi.init(sandTableId);

  // 解决沙盘标记点ICON丢失问题
  const filteredSandBox = data.sandBox.map((x) => {
    x.markers = (x.markers as STMapMarker[]).filter((m) => !!m.icon);
    return x;
  });

  // 经典免费版转为经典2.0
  const templateId =
    data.templateId === TemplateId.free ? TemplateId.vip : data.templateId;

  const origData = {
    ...data,
    templateId,
    sandBox: filteredSandBox,
  };

  $origTourDataApi.set(origData);

  $tourDataApi.set(origData);
}

export default dataHandler;
